import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import Header from "../header/HeaderComponent";
import Sidebar from "../sidebar/SidebarComponent";
import AppDuc from "../duc";

import "./AuthWrapper.scss";

const AuthWrapper = (props) => {
  useEffect(() => {
    if (props.isLoggedIn == null) {
      props.getFeatures();
    }
  }, [props]);

  if (props.isLoggedIn === false) {
    window.location.href = "/";
  } else if (props.isLoggedIn) {
    return (
      <div className="content-wrapper">
        <Header />
        <div className="auth-layout">
          <div className="auth-sidebar">
            <Sidebar path={props.path} />
          </div>
          <div className="auth-main">
            <div className={props.showMobileSidebar ? "container-fixed" : "container-desktop"}>
              {props.children}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div>Loading...</div>;
  }
};

const mapDispatchToProps = (dispatch) => ({
  getFeatures: () => dispatch(AppDuc.creators.tryLoggingIn()),
});

export default connect(
  createStructuredSelector({
    isLoggedIn: AppDuc?.selectors?.isLoggedIn,
    showMobileSidebar: AppDuc?.selectors?.showingMobileMenu,
  }),
  mapDispatchToProps
)(withRouter(AuthWrapper));
